import React from 'react';
import { Helmet } from 'react-helmet-async';
import styles from './About.module.css';

const About = () => {
  return (
    <div className={styles.container} role="main">
      <Helmet>
        <title>About Us - BGRS - Builder Grade Railing System</title>
        <meta name="description" content="Learn more about our company and our mission." />
        <meta name="keywords" content="about, company, mission" />
      </Helmet>
      <h1 tabIndex="0">About Us</h1>
      <p tabIndex="0">
        At ABC Railings, we pride ourselves on crafting architectural railing systems that not only deliver unmatched quality but also push the boundaries of design and engineering. While our original products were renowned for their premium appeal, we encountered two primary challenges: cost and timeline.
      </p>
      <p tabIndex="0">
        The precision and intricacy of our railings made them highly sought after, but the detailed process resulted in higher prices—still competitive, yet a concern for builders looking for a more accessible option. Additionally, the craftsmanship required extended lead times, as each system was meticulously created to ensure it met our exacting standards.
      </p>
      <div className={styles.quoteContainer} role="blockquote" aria-label="Customer Quote">
        <p className={`${styles.quoteText} ${styles.italic}`} tabIndex="0">
          "Our builder-grade railing system was thoughtfully designed with builders in mind, providing a cost-effective solution without sacrificing quality or style."
        </p>
      </div>
      <p tabIndex="0">
        Determined to address these challenges without compromising on quality, we embarked on a months-long development journey. The result? Our revolutionary builder-grade railing system. This system is not only cost-effective but also assembled on-site, eliminating installation lead times while maintaining the premium aesthetic of a fully welded system.
      </p>
      <p tabIndex="0">
        We are immensely proud to offer a product that outshines competitors both in appearance and structural integrity. Our railings comply with the National Building Code, ensuring safety and durability while retaining the luxurious feel that defines our brand.
      </p>
    </div>
  );
};

export default About;